require('./brokerETFsSellStep1.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { connect } = require('react-redux');
const classNames = require('classnames');

// @helpers
const {
    FIRST_STEP,
    BROKER_STOCKS_CONTRACT_DROPDOWN_TITLES_MODIFIER,
    BROKER_ORDER_TYPE_TO_MARKET,
    BROKER_ORDER_TYPE_FOR_THE_BEST,
    BROKER_ORDER_TYPE_LIMITED,
    BROKER_ETFS_SELL_FIELDS_MAXLENGHT_LIMIT,
    SPANISH_CONTINUES_MARKET_ISO_CODE,
    TYPE_ETFS,
    MAX_FRACTION_LENGTH_IN_STORE_LIMITED,
    NON_NUMERIC_REGEXP
} = require('constants/index');
const { DATE_PICKER_CUSTOM_PLACEHOLDER, DATE_PICKER_CUSTOM_LOCALE, DATE_PICKER_CUSTOM_DATE_FORMAT } = require('constants/commonsComponents');
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;

// @commons
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const DatePickerCustom = require('components/datePickerCustom/datePickerCustom');
const StocksContractDropdown = require('components/broker/commons/stocksContractDropdown/stocksContractDropdown');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const { InputSafe } = require('commonsComponents/inputSafe');
const { AmountInput } = require('commonsComponents/amountInput');

// @ actions
const BrokerETFsSellActions = require('actions/brokerETFsSell');

class BrokerETFsSellStep1 extends React.Component {
    constructor(props) {
        super(props);
        this.handleOrderTypeRadiosChange = this.handleOrderTypeRadiosChange.bind(this);
        this.handleOrderTypeInputChange = this.handleOrderTypeInputChange.bind(this);
        this.handleTitleQuantityChanged = this.handleTitleQuantityChanged.bind(this);
        this.onHandleDateChange = this.onHandleDateChange.bind(this);
        this.handleStockContractChanged = this.handleStockContractChanged.bind(this);
    }

    componentDidMount() {
        const { immBrokerETFsSell } = this.props;
        const contractSellNumber = immBrokerETFsSell.getIn(['steps', FIRST_STEP, 'selectedOptionValue']);
        const stocksContractDropdownOptions = this.buildStocksContractDropdownOptions();
        const stocksContractSelectedValue = this.getPrechoosedContract(contractSellNumber, stocksContractDropdownOptions);
        const titleQuantity = immBrokerETFsSell.get('steps').get(FIRST_STEP).get('titleQuantity');

        if (stocksContractSelectedValue !== -1) {
            this.handleStockContractChanged(stocksContractSelectedValue)
        } else if (stocksContractDropdownOptions.length === 1 && !titleQuantity) {
            this.handleStockContractChanged(stocksContractDropdownOptions[0].value);
        }
    }

    onHandleDateChange(date) {
        this.props.validityDateChanged(date);
    }

    getPrechoosedContract(contractSellNumber, options) {
        let optionIndex = -1;
        options.map(option => {
            if (option.contactNumber === contractSellNumber) {
                optionIndex = option.value;
            }
        });
        return optionIndex;
    }

    getStockCode() {
        const { immMyInvestments, params } = this.props;

        const etfs = immMyInvestments.getIn(['products', 'etfs', 'stocks']).find(stock => {
            return params.isin === stock.get('isin') && params.iso === stock.get('iso');
        });
        const etfCode = etfs ? etfs.get('valueCode') + etfs.get('emisionCode') : '';
        return etfCode;
    }

    buildForTheBestRadioButton() {
        if (this.shouldShowBestOptionRadioButton()) {
            return (
                <RadioButton
                    label={formatText('broker-etfsSellStep1ForTheBestLabel')}
                    value={BROKER_ORDER_TYPE_FOR_THE_BEST}
                    className="etfs-sell-step1__radio-button"
                />
            );
        }
    }

    buildRadioButtons() {
        const { productFile } = this.props;
        const forTheBestRadioButton = this.buildForTheBestRadioButton();
        const limitedLabel = `${formatText('broker-etfsSellStep1LimitedLabel')} (${productFile.get(
            'currency'
        )})`;

        const marketRadioButton = (
            <RadioButton
                label={formatText('broker-etfsSellStep1ToMarketLabel')}
                value={BROKER_ORDER_TYPE_TO_MARKET}
                className="etfs-sell-step1__radio-button"
            />
        );

        const limitedRadioButton = (
            <RadioButton
                label={limitedLabel}
                value={BROKER_ORDER_TYPE_LIMITED}
                className="etfs-sell-step1__radio-button"
            />
        );

        const radioButtons = [marketRadioButton, forTheBestRadioButton, limitedRadioButton];

        return radioButtons.filter(value => value !== undefined);
    }

    buildStocksContractDropdownOptions() {
        const { immStocksContracts } = this.props;

        const etfCode = this.getStockCode();
        const filteredContracts = immStocksContracts.filter(entry => {
            return entry.getIn(['stocks', etfCode]);
        });

        const processedStocksContract = filteredContracts.map(entry => {
            const newEntry = entry.merge({
                value: entry.get('contactNumber'),
                titlesQuantity: entry.getIn(['stocks', etfCode, 'sellables']),
                productType: TYPE_ETFS
            });

            return newEntry;
        });

        return processedStocksContract.toJS();
    }

    handleOrderTypeInputChange(value) {
        const { productFile } = this.props;
        const sellPrice = parseInt(productFile.get('sellPrice'), 10) + 1; // @TODO this should be reviewed

        this.props.orderTypeValueChanged(value, sellPrice);
    }

    handleOrderTypeRadiosChange(value) {
        const { orderTypeOptionChanged, productFile, orderTypeValueChanged } = this.props;
        const sellPrice = parseInt(productFile.get('sellPrice'), 10) + 1; // @TODO this should be reviewed
        orderTypeValueChanged('', sellPrice);
        orderTypeOptionChanged(value);
    }

    handleStockContractChanged(value) {
        const { immStocksContracts, immBrokerETFsSell,
            titleQuantityChanged, stockContractChanged } = this.props;
        const etfCode = this.getStockCode();
        const selectedContract = immStocksContracts.find(entry => {
            return entry.get('contactNumber') === value
        });
        const contractTitles = selectedContract.getIn(['stocks', etfCode, 'sellables'])
        stockContractChanged(value, contractTitles);

        const titleQuantity = immBrokerETFsSell.getIn(['steps', FIRST_STEP, 'titleQuantity']);
        const titleChangedManually = immBrokerETFsSell.getIn(['steps', FIRST_STEP, 'titleChangedManually']);
        if (!titleChangedManually) {
            titleQuantityChanged(contractTitles, false);
        } else {
            titleQuantityChanged(titleQuantity, true);
        }
    }

    handleTitleQuantityChanged(event) {
        this.props.titleQuantityChanged(event.target.value.replace(NON_NUMERIC_REGEXP, "").trim(), true);
    }

    shouldShowBestOptionRadioButton() {
        const { productFile } = this.props;

        // Get the two first letter from ISIN to know if it is a spanish market
        return productFile.get('micCode') === SPANISH_CONTINUES_MARKET_ISO_CODE;
    }

    render() {
        const { immBrokerETFsSell } = this.props;
        const stocksContractDropdownOptions = this.buildStocksContractDropdownOptions();
        let stocksContractSelectedValue = immBrokerETFsSell
            .get('steps')
            .get(FIRST_STEP)
            .get('stocksContractSelectedValue');
        const stocksContractPlaceholder = formatText('broker-stocksContractDropdownPlaceholder');
        const step1 = immBrokerETFsSell.get('steps').get(FIRST_STEP);
        const orderTypeOption = step1.get('orderTypeOption');
        const orderTypeValue = step1.get('orderTypeValue');
        const firstDate = step1.get('firstDate');
        const limitDate = step1.get('limitDate');
        const validityDate = step1.get('validityDate');
        const titleQuantity = step1.get('titleQuantity');
        const errorFlags = step1.get('errorFlags');
        const excludeDates = step1.get('excludeDates');
        let titleQuantityValid = step1.get('titleQuantityValid');
        let titleQuantityLimitValid = step1.get('titleQuantityLimitValid');

        const resultedErrorState = !titleQuantityValid || !titleQuantityLimitValid;
        const titleQuantityErrorMessage = titleQuantityLimitValid
            ? formatText('broker-etfsSellStep1TitleQuantityMin')
            : formatText('broker-etfsSellStep1TitleQuantityMax');

        const existsBestOptionRadioButton = this.shouldShowBestOptionRadioButton();
        const orderTypeInputCustomClass = classNames(
            'etfs-sell-step1__input etfs-sell-step1__order-type-input',
            {
                'etfs-sell-step1__order-type-input--second-place': !existsBestOptionRadioButton,
                'etfs-sell-step1__order-type-input--third-place': existsBestOptionRadioButton,
                hidden: orderTypeOption !== BROKER_ORDER_TYPE_LIMITED
            }
        );
        const language = getLanguage();
        const limitedCallback = this.handleOrderTypeInputChange;
        const orderTypeInput = (
            <div className={orderTypeInputCustomClass}>
                <AmountInput
                    min={0}
                    amount={orderTypeValue}
                    autoComplete="off"
                    callback={limitedCallback}
                    error={errorFlags.get('orderTypeValue')}
                    errorMsg={formatText('broker-etfsSellViewOrderTypeError')}
                    maxBackEndFractionLength={MAX_FRACTION_LENGTH_IN_STORE_LIMITED}
                    language={language}
                />
            </div>
        );
        const comboDisabled = stocksContractDropdownOptions.length === 1;
        const contractSellNumber = immBrokerETFsSell.getIn(['steps', FIRST_STEP, 'selectedOptionValue']);

        if (contractSellNumber) {
            stocksContractSelectedValue = this.getPrechoosedContract(
                contractSellNumber,
                stocksContractDropdownOptions
            );
        }

        const contractErrorState = errorFlags.get('isETFsContractEmpty');
        const orderTypeRadioButtons = this.buildRadioButtons();

        return (
            <div className="etfs-sell-step1">
                <header className="etfs-sell-step1__header">
                    <h2 className="etfs-sell-step1__header-title">
                        <FormattedText value="broker-etfsSellViewStep1HeaderTitle" />
                    </h2>
                </header>

                <div className="etf-sell-step1__dropdown">
                    <StocksContractDropdown
                        onStockContractChange={this.handleStockContractChanged}
                        options={stocksContractDropdownOptions}
                        selectedValue={stocksContractSelectedValue}
                        placeholder={stocksContractPlaceholder}
                        modifier={BROKER_STOCKS_CONTRACT_DROPDOWN_TITLES_MODIFIER}
                        disabled={comboDisabled}
                        errorState={contractErrorState}
                        errorMessage={formatText('broker-stocksSellStep1NoAccountError')}
                    />
                </div>

                <div className="stocks-sell-step1__group-div">
                    <h2 className="stocks-sell-step1__subtitle">
                        <FormattedText value="broker-etfsSellStep1TitleQuantity" />
                    </h2>
                    <div className="stocks-sell-step1__text-input-wrapper stocks-sell-step1__text-input-wrapper--left">
                        <InputSafe
                            type="text"
                            value={titleQuantity}
                            autoComplete="off"
                            onChange={this.handleTitleQuantityChanged}
                            maxLength={BROKER_ETFS_SELL_FIELDS_MAXLENGHT_LIMIT}
                            errorState={resultedErrorState}
                            errorMessage={titleQuantityErrorMessage}
                        />
                    </div>
                </div>

                <div className="etfs-sell-step1__group-div">
                    <h2 className="etfs-sell-step1__subtitle etfs-sell-step1__subtitle--inline">
                        <FormattedText value="broker-etfsSellViewStep1OrderTypeText" />
                        <OKTooltip
                            content="broker-etfsSellViewOrderTypeTooltipText"
                            offset={[0, -15]}
                        />
                    </h2>

                    <RadioButtonGroup
                        selectedValue={orderTypeOption}
                        onChange={this.handleOrderTypeRadiosChange}
                        name="orderTypeRadioGroup"
                        idPrefix="orderTypeRadioGroup"
                    >
                        {orderTypeRadioButtons}
                    </RadioButtonGroup>
                    {orderTypeInput}
                </div>

                <div className="etfs-sell-step1__group-div">
                    <h2 className="etfs-sell-step1__subtitle etfs-sell-step1__subtitle--inline">
                        <FormattedText value="broker-etfsSellViewStep1ValidityDateLabel" />
                        <OKTooltip
                            content="broker-etfsSellViewValidityDateTooltipText"
                            offset={[0, -15]}
                        />
                    </h2>
                    <div className="etfs-sell-step1__date-picker">
                        <DatePickerCustom
                            callback={this.onHandleDateChange}
                            selectedDate={validityDate}
                            newSelectedDate={validityDate}
                            maxDate={limitDate}
                            minDate={firstDate}
                            excludeDates={excludeDates}
                            placeholder={formatText(DATE_PICKER_CUSTOM_PLACEHOLDER)}
                            locale={formatText(DATE_PICKER_CUSTOM_LOCALE)}
                            dateFormat={formatText(DATE_PICKER_CUSTOM_DATE_FORMAT)}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

BrokerETFsSellStep1.propTypes = {
    immBrokerETFsSell: PropTypes.object.isRequired,
    immStocksSell: PropTypes.object.isRequired,
    immStocksContracts: PropTypes.object.isRequired,
    immMyInvestments: PropTypes.object.isRequired,
    params: PropTypes.object.isRequired,
    stockContractChanged: PropTypes.func.isRequired,
    validityDateChanged: PropTypes.func.isRequired,
    titleQuantityChanged: PropTypes.func.isRequired,
    orderTypeOptionChanged: PropTypes.func.isRequired,
    orderTypeValueChanged: PropTypes.func.isRequired,
    productFile: PropTypes.object.isRequired
};

module.exports.constructor = BrokerETFsSellStep1;

module.exports.BrokerETFsSellStep1 = connect(
    state => ({
        immBrokerETFsSell: state.brokerETFsSell,
        immStocksContracts: state.brokerStocksContract,
        immStocksSell: state.brokerStocksSell,
        immMyInvestments: state.brokerMyInvestments,
        productFile: state.brokerProductFile
    }),
    {
        stockContractChanged: BrokerETFsSellActions.stockContractChanged,
        validityDateChanged: BrokerETFsSellActions.validityDateChanged,
        titleQuantityChanged: BrokerETFsSellActions.titleQuantityChanged,
        orderTypeOptionChanged: BrokerETFsSellActions.orderTypeOptionChanged,
        orderTypeValueChanged: BrokerETFsSellActions.orderTypeValueChanged
    }
)(BrokerETFsSellStep1);
